export const serviceRequestPathFragment = {
  SERVICE_REQUEST: "SERVICE_REQUEST",
} as const;

export const serviceRequestRoutes = {
  [serviceRequestPathFragment.SERVICE_REQUEST]: "service_requests/:id",
};
